module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('top-bar-search'), _vm._v(" "), _c('top-bar-alert')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43be26c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Templates/MainCustomTopBar.vue
// module id = 691
// module chunks = 1